// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f4l0","col":"styles_col__2vKuZ","actions":"styles_actions__1V80e","conflict":"styles_conflict__3vb3D"};